import React from 'react';
import './admin-portal-style.scss';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import ExportList from './ExportList';
import useGetData from './useGetData';
import { Tabs, Tab } from '../common/Tabs';
import EmailContainer from './NotificationConfig';

function AdminPortal() {
  const { response, error, isLoading } = useGetData();

  const data = response ? response.emails : [];
  const columns = [{
    Header: 'Email',
    accessor: 'email',
  }, 
  {
    Header: 'Notify Email',
    accessor: 'notifyEmail',
  },
  {
    Header: 'CreatedAt',
    accessor: 'createdAt',
  },
  ];

  return (
    <div className="admin__portal__wrapper">
      <h1>Admin Portal</h1>

      <Tabs>
        <Tab label="View Emails">
          <h3>View Emails </h3>
          <ReactTable
            className="-stripped -highlight"
            data={data}
            columns={columns}
            defaultPageSize={5}
          />
        </Tab>
        <Tab label="Export Data">
          <h3> Export Data </h3>
          <ExportList />
          <div />
        </Tab>
        <Tab label="Notification Config">
          <EmailContainer />
        </Tab>
      </Tabs>

    </div>

  );
}

export default AdminPortal;
